import { render, staticRenderFns } from "./DataInputDecimal.vue?vue&type=template&id=1d2617cc&"
import script from "./DataInputDecimal.vue?vue&type=script&lang=js&"
export * from "./DataInputDecimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports